import React from 'react';
import TOGGLE_LEGENDS_IMG from './assets/info-grey.png';
import TOGGLE_LEGENDS_SELECTED_IMG from './assets/info-white.png';
import styled from 'styled-components';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { commonTooltipInlineStyle } from '../utilities/constants';

const enabledBackgroundColor = '#2e98e3';
const disabledBackgroundColor = '#FFFFFF';
const legendButtonTooltipId = 'legend-button-tool-tip';

interface LegendToggleType {
    toggleLegend: () => void;
    legendEnabled: boolean;
    showBorder: boolean;
}

export const LegendToggle = ({ 
    toggleLegend,
    legendEnabled,
    showBorder
}: LegendToggleType) => {
    const borderRightColor = `1px solid ${legendEnabled ? '#FFFFFF' : '#D8D8D8'}`;

    return <div id='mapLegendToggleOuterContainer'>
        <ActionButton 
            id='mapLegendToggleButtonContainer'
            legendEnabled={legendEnabled}
            showBorder={showBorder}
            borderRightColor={borderRightColor}
            onClick={toggleLegend}
            data-tooltip-id={legendButtonTooltipId}
        >
            <Icon 
                id='mapLegendToggleIcon' 
                className='mapIcon'
                alt='Map legend toggle'
                src={legendEnabled ? TOGGLE_LEGENDS_SELECTED_IMG : TOGGLE_LEGENDS_IMG}
            />
        </ActionButton>
        <ReactTooltip 
            style={commonTooltipInlineStyle} 
            positionStrategy='fixed'
            effect='solid'  
            content='Map Legend'
            id={legendButtonTooltipId} />
    </div>;
};

interface ActionButtonProps {
    legendEnabled: boolean;
    showBorder: boolean;
    borderRightColor: string;
}
const ActionButton = styled.div<ActionButtonProps>`
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: center;
    width: 92px;
    cursor: pointer;
    height: 46px;
    background-color: ${({ legendEnabled }) => legendEnabled ? enabledBackgroundColor : disabledBackgroundColor};
    border-right: ${({ showBorder, borderRightColor }) => showBorder ? borderRightColor : 'none'};
`;

const Icon = styled.img`
    max-height: 26px;
`;
